import React from 'react';

import Steps from 'mx_pcb_assembly/components/Steps';
import Parameters from 'mx_pcb_assembly/components/Parameters';
import Loading from 'mx_pcb_assembly/components/Loading';
import Price from 'mx_pcb_assembly/components/Price';
import Alert from 'mx_pcb_assembly/components/Alert';
import { useSelector } from 'react-redux';

const App = () => {
  const {
    quoteStep
  } = useSelector((state) => state.mx_assembly)

  return (
    <div>
      <Alert />
      <Loading />
      <Steps quoteStep={quoteStep} />
      <div className="row">
        <div className="col-lg-4">
          <Parameters />
        </div>
        <div className="col-lg-8">
          <div className="pcb-price-section">
            <Price />
          </div>
        </div>
      </div>
    </div>
  )
}

export default App;
